import { Link } from 'react-router-dom';

import { TEntityGridColumn } from 'app/common/entity-grid/core';
import {
  OneOfFilterDataGrid,
  StringFilterDataGrid,
} from 'app/common/ui/data-grid/filters';
import { appRoute } from 'app/railways/router/routes';

import { EAccountStatus } from '../../core/account-status';
import { TPersonData } from '../../core/person';
import { EPhoneStatus } from '../../core/phone-status';

const phoneStatusTitle: Record<EPhoneStatus, string> = {
  [EPhoneStatus.new]: 'Новый',
  [EPhoneStatus.confirmed]: 'Подтвержден',
  [EPhoneStatus.codeSended]: 'Ожидает подтверждения',
};

const accountStatusTitle: Record<EAccountStatus, string> = {
  [EAccountStatus.new]: 'Новый',
  [EAccountStatus.blocked]: 'Заблокирован',
  [EAccountStatus.active]: 'Активен',
};

export const cols: TEntityGridColumn<TPersonData>[] = [
  {
    field: 'id',
    // type: 'rightAligned',
    headerName: 'ID',
    minWidth: 50,
    headerCheckboxSelection: true,
    checkboxSelection: true,
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: number }) => {
      const personDetailsPath = appRoute.PERSON.DETAILS.buildPath({
        passengerId: value,
      });

      return <Link to={personDetailsPath}>{value}</Link>;
    },
    filter: StringFilterDataGrid({
      filterName: 'id',
      placeholder: 'Введите ID заказа',
    }),
  },
  {
    field: 'phone',
    headerName: 'Номер телефона',
    colId: 'phone',
    sortable: true,
    comparator: () => 0,
    filter: StringFilterDataGrid({
      filterName: 'phone',
      placeholder: 'Введите номер телефона',
    }),
  },
  {
    field: 'accountStatus',
    headerName: 'Статус аккаунта',
    colId: 'accountStatus',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: EAccountStatus }) => {
      return (
        <>{typeof value === 'number' ? accountStatusTitle[value] : null}</>
      );
    },
    filter: OneOfFilterDataGrid({
      filterName: 'accountStatus',
      options: [
        { value: 0, label: 'Новый' },
        { value: 1, label: 'Активен' },
        { value: 2, label: 'Заблокирован' },
      ],
    }),
  },
  {
    field: 'phoneStatus',
    headerName: 'Статус телефона',
    colId: 'phoneStatus',
    sortable: true,
    comparator: () => 0,
    cellRenderer: ({ value }: { value: EPhoneStatus }) => {
      return <>{typeof value === 'number' ? phoneStatusTitle[value] : null}</>;
    },
  },
];
